import { TextInput } from "@msuite/ui/form";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { ProjectInvoiceSchema } from "@msuite/utils/schemas";
import { useFormContext, useWatch } from "react-hook-form";

export function ProjectInvoiceFormProgressInvoiceNumber() {
	/** Context */
	const methods = useFormContext<ProjectInvoiceSchema>();

	/** Hooks */
	const type = useWatch({ control: methods.control, name: "type" });
	const { t } = useTranslation();

	/** Guard */
	if (type !== "progress-invoice") return null;

	/** Render */
	return (
		<TextInput
			label={t("invoices.progress_invoice_number")}
			control={methods.control}
			name="progressInvoiceNumber"
			defaultValue={1}
			isRequired
			type="number"
			leftIcon={icon("Hash")}
			placeholder="1"
			step={1}
			data-cy="project-invoice-progress-number"
		/>
	);
}
